import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';
import "./assets/style/theme/index.css";

Vue.use(ElementUI);

import VueMarkdownEditor from "@kangc/v-md-editor";
import "@kangc/v-md-editor/lib/style/base-editor.css";
import vuepressTheme from "@kangc/v-md-editor/lib/theme/vuepress.js";
import "@kangc/v-md-editor/lib/theme/style/vuepress.css";
import Prism from "prismjs";
//拖拽box
import '@/utils/dialog'

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});
Vue.use(VueMarkdownEditor);

//echarts
import "echarts";

Vue.config.productionTip = false;

// const vueInstance = new Vue({
//   router,
//   store,
//   render: (h) => h(App),
//   beforeCreate() {
//     Vue.prototype.$bus = this; //安装全局事件总线，$bus就是当前应用的vm
//     Vue.prototype.$eventBus = this; // 安装全局事件总线
//   },
// }).$mount("#app");
// // 将 Vue 实例挂载到全局对象上
// window.vueInstance = vueInstance;
// export default vueInstance; // 导出 Vue 实例

import { EventBus } from './utils/event-bus.js';
 // 将事件总线添加到Vue原型，使其可以在任何组件中通过this.$bus访问
Vue.prototype.$bus = EventBus;
  
export default new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
        Vue.prototype.$bus = this; //安装全局事件总线，$bus就是当前应用的vm
  },
}).$mount("#app");